import store from "@/store";
import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";
import BudgetReport from "../pages/Reports/BudgetReport/index";
import UDNReport from "../pages/Reports/UDNReport";
import inventoryLogs from "@/pages/Reports/InventoryLog/Index";
import InputsOutputsReport from '@/pages/Reports/InputsOutputsReport/Index'
// import DirectCost from "@/pages/Reports/DirectCost/Index";
import RejectQuantification from "@/pages/Reports/RejectedQuantification/Index";

const DynamicReportExec = () => import("../pages/DynamicReports/Exec");

const reports = {
  path: "/",
  component: DashboardLayout,
  name: "Reports",
  title: "Reportes",

  icon: "table_chart",
  excludedGroups: ["Extranet"],
  excludedRoles: ["IDEAL"],
  children: [
    {
      path: "/reportes/almacen",
      name: "Existencias en almacén",
      title: "Existencias en almacén",
      meta: {
        ifUserCan: {
          can_view_reports: "IWarehouse/iwarehouse",
        },
      },
      component: inventoryLogs,
    },
    {
      path: "/reportes/movimientos-inventario",
      name: "Entradas y salidas por almacén",
      title: "Bitácora de almacén",
      meta: {
        ifUserCan: {
          can_view_reports: "IWarehouse/iwarehouse",
        },
      },
      component: InputsOutputsReport,
    },
    // {
    //   path: '/reportes/costo_directo',
    //   name: 'Direct Cost',
    //   title: 'Costo Directo',
    //   meta: {
    //     ifUserCan: {
    //       // view_direct_cost_report: 'Roads/sinisterroads'
    //     },
    //   },
    //   component: DirectCost,
    // },
    {
      path: "/reportes/comparativa_estimado_utilizado",
      name: "Comparativa estimado/realizado",
      title: "Comparativa estimado/realizado",
      meta: {
        ifUserCan: {
          // :TODO: Set report permission
          can_view_budget_report: "Quantification/quantification",
        },
      },
      // roles: ['ADM', 'KAM', 'ESAT'],
      component: BudgetReport,
    },
    {
      path: "/reportes/udn",
      name: "UDN Carreteros",
      title: "UDN Carreteros",
      // roles: ['ADM', 'KAM', 'ESAT'],
      meta: {
        ifUserCan: {
          udn_report: "Sinister/affected",
        },
      },
      component: UDNReport,
    },
    {
      path: "/reportes/archivo-maestro/",
      props: () => ({
        report: "archivo-maestro",
        editable: !!store.getters["account/userRoleIs"]("ADM", "AUDITOR"),
        tableProps: {
          propsToSearch: ["sinister_number", "requisition_number"],
          tableCurrentSort: "requisition_number",
          tableCurrentSortOrder: "desc",
        },
      }),
      name: "Archivo Maestro",
      title: "Archivo Maestro",
      // roles: ['ADM', 'AUDITOR', 'GECA'],
      meta: {
        ifUserCan: {
          view_master: "DynamicReports/report",
        },
      },
      component: DynamicReportExec,
    },
    {
      path: "/reportes/cuentas-de-proveedor/",
      props: () => ({
        report: "cuentas-de-proveedor-finanzas",
        tableProps: {
          tableCurrentSort: "creation_date",
          tableCurrentSortOrder: "desc",
        },
      }),
      name: "Cuentas de Proveedor",
      title: "Cuentas de Proveedor",
      meta: {
        ifUserCan: {
          can_view_provider_finance: "DynamicReports/report",
        },
      },
      component: DynamicReportExec,
    },
    {
      path: "/reportes/compras/",
      props: () => ({
        report: "reporte-de-compras",
        tableProps: {
          propsToSearch: [
            "sinister_number",
            "requisition_number",
            "purchase_requisition_folio",
            "material_requisition_folio",
          ],
        },
      }),
      name: "Reporte de Compras",
      title: "Reporte de Compras",
      // roles: ['ADM', 'AUDITOR', 'GECA'],
      meta: {
        ifUserCan: {
          view_purchase: "DynamicReports/report",
        },
      },
      component: DynamicReportExec,
    },
    {
      path: "/reportes/cuantificaciones-rechazadas/",
      name: "Rechazos de cuantificación",
      title: "Rechazos de cuantificación",
      meta: {
        ifUserCan: {
          can_view_rejected_report: "Quantification/quantification",
        },
      },
      component: RejectQuantification,
    },
    {
      path: "/reportes/cotizaciones/",
      props: () => ({
        report: "detalle-de-cotizacion",
        //tableProps: {
        //propsToSearch: ['sinister_number', 'requisition_number', 'purchase_requisition_folio', 'material_requisition_folio'],
        //},
      }),
      name: "Reporte de Cotizaciones",
      title: "Reporte de Cotizaciones",
      meta: {
        ifUserCan: {
          view_quotation_detail: "DynamicReports/report",
        },
      },
      component: DynamicReportExec,
    },
    {
      path: "/reportes/cotizaciones-sin-autorizar/",
      props: () => ({
        report: "cotizaciones-sin-autorizar",
        //tableProps: {
        //propsToSearch: ['sinister_number', 'requisition_number', 'purchase_requisition_folio', 'material_requisition_folio'],
        //},
      }),
      name: "Cotizaciones sin autorizar",
      title: "Cotizaciones sin autorizar",
      meta: {
        ifUserCan: {
          view_unauthorized_quotation: "DynamicReports/report",
        },
      },
      component: DynamicReportExec,
    },
  ],
};

export default reports;



// WEBPACK FOOTER //
// ./src/router/reportsRoutes.js